import { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Image, Typography, Row, Col, Card } from 'antd';
import { UserMigrationDetails } from 'all-in-one-shared-api/dist/apis/user/usePatchExistingUser';
import generateKey from 'utils/generateKey';
import { useInterval } from 'hooks/useInterval';
import mobileIcon from 'assets/images/neutral-1.svg';
import emailIcon from 'assets/images/Group 3.svg';
import type { InputRef } from 'antd';
import styled from 'styled-components';
import { getConfig } from 'configs';
import {
  useAddAnotherEbValidate,
  useEmailOtpValidate,
  useAddAnotherEb,
  useSwitchEbPolicy,
} from 'all-in-one-shared-api';
import './otp.less';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { osName, osVersion } from 'react-device-detect';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import { InvalidTextMsg, ResendCaptchaSection, SubTitle } from 'pages/registration/otp-verification/styledComponents';
import { NewInput } from 'pages/life/registration/otp-verification/styledComponents';
import GoogleCaptcha from 'components/googleCaptcha';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import jwtDecode from 'jwt-decode';
const { Title, Text, Link } = Typography;

const RESEND_COUNTDOWN_PERIOD = 60;

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');

interface LocationState extends UserMigrationDetails {
  prevPath?: string;
  saveTodb?: boolean;
  email?: string;
  type?: string;
  selfDefinedLoginId?: string;
  password?: string;
  policyNumber?: string;
  memberType?: string;
  dob?: string;
  pwd?: string;
  birthDate: string;
  memberId?: string;
  identityNo: string;
}
// type ebCardPropList = {
//   policyNumber: string;
//   memberId: string;
//   effectiveStart: string;
//   effectiveEnd: string;
//   policyStatus: string;
// };
const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
export const EbProfileConnectOtp = (): JSX.Element => {
  const [otpArray, setOtpArray] = useState('');
  const [isAllowEdit, setIsAllowEdit] = useState(false);
  const { keycloak } = useKeycloak();
  const { tokenParsed } = useKeycloakReady();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [requestOtpCount, setRequestOtpCount] = useState(0);
  const [isShowCaptcha, setIsShowCaptcha] = useState(false);
  const location = useLocation();
  const loginId = tokenParsed?.preferred_username;
  const { email, policyNumber, birthDate, memberId } = (location.state as LocationState) ?? {};
  const [randoms, setRandoms] = useState(Math.random());
  const [retryCount, setRetryCount] = useState(0);

  const [key, setKey] = useState<string>('');

  const {
    shouldFetch: AddAnotherEbFetch,
    data: AddAnotherEbData,
    error: AddAnotherEbError,
  } = useAddAnotherEb(
    'useAddAnotherEb',
    keycloak.token as string,
    policyNumber || '',
    memberId || '',
    birthDate,
    otpArray,
  );

  const { shouldFetch: EbPolicyValidateFetch } = useAddAnotherEbValidate(
    key,
    keycloak.token as string,
    policyNumber ?? '',
    memberId ?? '',
    birthDate ?? '',
    {
      shouldRetryOnError: false,
      onSuccess: () => {
        EbPolicyValidateFetch(false);
      },
      onError: (error) => {
        if (error) {
          EbPolicyValidateFetch(false);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
        }
      },
    },
  );

  const [validateKey, setValidateKey] = useState<string>('');
  const { shouldFetch: shouldEmailValidate /*, isLoading: isValidating */ } = useEmailOtpValidate(
    validateKey,
    loginId ?? '',
    otpArray,
    {
      shouldRetryOnError: false,
      onSuccess: (validateResponse) => {
        shouldEmailValidate(false);
        if (validateResponse) {
          if (validateResponse.success) {
            setErrorMsg(null);
            startUsing();
          } else {
            //光標移入第一個輸入框
            if (digit1InputRef.current) {
              digit1InputRef.current.focus();
            } else {
              console.error('digit1InputRef.current is null');
            }
            setOtpArray('');
            setErrorMsg(validateResponse.message);
          }
        }
      },
      onError: (error) => {
        if (error) {
          shouldEmailValidate(false);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
        }
      },
    },
  );
  useInterval(
    () => {
      setCountdown(countdown - 1);
    },
    countdown >= 0 ? 1000 : null,
  );
  const digit1InputRef = useRef<InputRef>(null);

  const handleResendOtp = () => {
    if (requestOtpCount < 3) {
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }

    setRequestOtpCount(requestOtpCount + 1);
    console.log('onPressResend()->');
    setKey(generateKey());

    setOtpArray('');
    setErrorMsg('life.register.resendOtp');
    if (digit1InputRef.current) {
      digit1InputRef.current.focus();
    }

    EbPolicyValidateFetch(true);
  };

  useEffect(() => {
    if (requestOtpCount >= 3) {
      setIsShowCaptcha(true);
    }
  }, [requestOtpCount]);

  const startUsing = async () => {
    AddAnotherEbFetch(true);
  };
  /* eslint-disable */
  useEffect(() => {
    if (AddAnotherEbData) {
      setRandoms(Math.random());
      SwitchEbPolicyFetch(true);
    }
    if (AddAnotherEbError && AddAnotherEbError.code) {
      const errorMessage = setErrorCodeFun(AddAnotherEbError.code, i18n.language);
      setErrorMsg(errorMessage ?? AddAnotherEbError.code ?? AddAnotherEbError.message);
    }
  }, [AddAnotherEbData, AddAnotherEbError]);
  const { shouldFetch: SwitchEbPolicyFetch } = useSwitchEbPolicy(
    'useSwitchEbPolicy' + randoms,
    keycloak.token as string,
    {
      onSuccess: (res) => {
        if (res) {
          SwitchEbPolicyFetch(false);
          refreshToken();
          setErrorMsg(null);
          setRetryCount(0);
        } else {
          SwitchEbPolicyFetch(false);
        }
      },
      onError: (err) => {
        const errorMessage = setErrorCodeFun(err.code, i18n.language);
        console.log(err.code, err.message, errorMessage);

        setErrorMsg(errorMessage ?? err.code ?? err.message);
        SwitchEbPolicyFetch(false);

        if (retryCount < 2) {
          setRetryCount((prev) => prev + 1);
          setTimeout(() => {
            SwitchEbPolicyFetch(true);
          }, 1000);
        } else {
          setRetryCount(0);
          navigate('/profile', {
            replace: true,
          });
        }
      },
    },
  );
  /* eslint-enable */
  const refreshToken = () => {
    const { preferred_username }: { preferred_username: string } = jwtDecode(keycloak.token ?? '');
    keycloak
      .login({
        action: 'refresh_token',
        username: preferred_username,
        refreshToken: keycloak.refreshToken,
        device: osName,
        deviceVersion: osVersion,
      })
      .then(() => {
        keycloak.updateToken(-1);
        console.log(keycloak.tokenParsed, '刷新之后');
        navigate('/profile', {
          replace: true,
        });
      });
  };

  const handleVerifyOtp = useCallback(() => {
    if (!/\d{6}/.test(otpArray)) {
      setErrorMsg(t('smsOtpVerification.code-not-found'));
      return;
    }

    setValidateKey(generateKey());
    shouldEmailValidate(true);
  }, [otpArray, setErrorMsg, setValidateKey, shouldEmailValidate, t]);
  useEffect(() => {
    if (otpArray.length === 6) {
      handleVerifyOtp();
    }
  }, [otpArray, handleVerifyOtp]);
  useEffect(() => {
    if (errorMsg && errorMsg == 'smsOtpVerification.retry-limit-exceeded') {
      setIsAllowEdit(true);

      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }
  }, [errorMsg]);
  useEffect(() => {
    if (countdown === 0) {
      setIsAllowEdit(false);
    }
  }, [countdown]);

  const onCaptchaSuccess = () => {
    setIsShowCaptcha(false);
  };

  const onCaptchaError = () => {
    setErrorMsg(t('login.error.captchaDigitError'));
  };

  const onOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    setOtpArray(e.target.value);
    setErrorMsg(null);
  };
  function maskEmail(email: string) {
    if (!email) return '';
    // ???????????????
    const [username, domain] = email.split('@');
    // const [domains, coms,countrys] = domain.split('.');
    const domainList = domain.split('.');

    // ???????,???1???1?,???*??
    const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.slice(-1);
    const maskedDomain = domainList[0].charAt(0) + '*'.repeat(domainList[0].length - 2) + domainList[0].slice(-1);
    if (domainList.length > 2) {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1] + '.' + domainList[2];
    } else {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1];
    }
    // ??????????
  }
  function maskPhoneNumber(phoneNumber: string) {
    if (!phoneNumber) return '';
    // ???3???4?,???*??
    const visibleDigits = 2; // ????,??????????
    const startDigits = phoneNumber.substring(0, visibleDigits);
    const endDigits = phoneNumber.substring(phoneNumber.length - 2);

    // ?????*?????
    const maskedPart = '*'.repeat(phoneNumber.length - visibleDigits - 2);

    // ??????????
    return startDigits + maskedPart + endDigits;
  }
  return (
    <ResponsiveContainer>
      <div
        className="register_otp_wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          padding: '20px',
        }}
      >
        <Card style={{ border: 0, width: '100%', maxWidth: '400px' }}>
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]}>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              {/* <Space align="center" direction="vertical"> */}
              <Title level={3} style={{ marginTop: '30px', fontSize: '26px', color: '#20252B' }}>
                {t('smsOtpVerification.screenTitle')}
              </Title>
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Image
                height="176px"
                className="img_container"
                src={email && !email.includes(' ') ? emailIcon : mobileIcon}
                preview={false}
              />
              {/* </Space> */}
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <SubTitle
                style={{ display: 'inline-block', textAlign: 'center', fontSize: '20px', fontFamily: 'Roboto400' }}
              >
                {email && !email.includes(' ')
                  ? t('smsOtpVerification.emailScreenSubtitle')
                  : t('smsOtpVerification.mobileScreenSubtitle')}
                <br />
                {email && !email.includes(' ')
                  ? maskEmail(email)
                  : email && email.includes(' ')
                  ? (() => {
                      const parts = email.split(' ');
                      return parts.length >= 2
                        ? parts[0] +
                            '  ' +
                            (parts.length > 2 ? parts[1] + '  ' : '') +
                            maskPhoneNumber(parts[parts.length - 1])
                        : parts.length === 1
                        ? maskPhoneNumber(parts[0])
                        : null;
                    })()
                  : null}
              </SubTitle>
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <NewInput
                maxLength={6}
                value={otpArray}
                onChange={onOtpChange}
                className="single-digit-input"
                autoFocus
                ref={digit1InputRef}
                disabled={isAllowEdit}
              />
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {errorMsg && (
                <InvalidTextMsg type="danger" style={{ marginLeft: 0 }}>
                  {t(errorMsg)}
                </InvalidTextMsg>
              )}
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <ResendCaptchaSection>
                {isShowCaptcha ? (
                  <GoogleCaptcha
                    hl={i18n.language}
                    sitekey={config.captchaSiteKey}
                    onChange={onCaptchaSuccess}
                    onError={onCaptchaError}
                    onExpired={onCaptchaError}
                  />
                ) : (
                  <>
                    <Link
                      onClick={countdown > 0 ? (e) => e.preventDefault() : handleResendOtp}
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        pointerEvents: countdown > 0 ? 'none' : 'auto',
                        color: countdown > 0 ? 'gray' : '#752127', // 设置禁用时颜色为灰色
                      }}
                    >
                      {t('smsOtpVerification.resend')}
                    </Link>
                    {countdown >= 0 && (
                      <Text type="secondary" style={{ color: '#20252B', fontSize: '17px', marginTop: 20 }}>
                        {t('smsOtpVerification.resendCountdownText', {
                          second: countdown,
                        })}
                      </Text>
                    )}
                  </>
                )}
              </ResendCaptchaSection>
            </Col>

            {/* <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '100%' }}>
                <Button block type="primary" disabled={disabledVerification} size="large" onClick={handleVerifyOtp}>
                  {t('common.submit')}
                </Button>
              </div>
            </Col> */}
            <Link
              onClick={() => {
                navigate('/EbProfileConnect');
              }}
              style={{
                fontSize: '17px',
                fontFamily: 'Roboto400',
                marginLeft: 4,
                marginRight: 4,
                color: '#C21B17',
                textDecoration: 'underline',
              }}
            >
              {t('common.cancel')}
            </Link>
          </Row>
        </Card>
      </div>
    </ResponsiveContainer>
  );
};
